import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import Navigation from "./components/Navigation";
import LoginPage from "./pages/LoginPage";
import MoodScanPage from "./pages/MoodScanPage";
import MoodFormulasPage from "./pages/MoodFormulasPage";
import SensoryResetPage from "./pages/SensoryResetPage";
import DashboardPage from "./pages/DashboardPage";
import CommunityWallPage from "./pages/CommunityWallPage";
import PremiumSuccessPage from "./pages/PremiumSuccessPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import InviteAcceptPage from "./pages/InviteAcceptPage";
import TrialBanner from "./components/TrialBanner";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import "./App.css";

function AppLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <Navigation />
      <main className="pt-6 md:pt-20 px-4 sm:px-6 pb-24 max-w-6xl mx-auto">
        <TrialBanner />
        {children}
      </main>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();

  // CRITICAL: Check URL fragment synchronously for session_id (OAuth callback).
  // Works on any route — deployed domain may redirect to different paths.
  const hasSessionId = location.hash?.includes("session_id=")
    || window.location.hash?.includes("session_id=");

  if (hasSessionId) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/invite/:token" element={<InviteAcceptPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <AppLayout><MoodScanPage /></AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/formulas"
        element={
          <ProtectedRoute>
            <AppLayout><MoodFormulasPage /></AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sessions"
        element={
          <ProtectedRoute>
            <AppLayout><SensoryResetPage /></AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tracking"
        element={
          <ProtectedRoute>
            <AppLayout><DashboardPage /></AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/community"
        element={
          <ProtectedRoute>
            <AppLayout><CommunityWallPage /></AppLayout>
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AppLayout><AdminDashboardPage /></AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/premium/success"
        element={
          <ProtectedRoute>
            <PremiumSuccessPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <PWAInstallPrompt />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
